import { MoneyInput, useInputValidation } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  amount: number;
  setAmount: (amount: number) => void;
}

export function Amount({ amount, setAmount }: IProps) {
  const [ref, isValid, message] = useInputValidation(amount, [
    { validation: (amount) => amount > 0, message: 'Upphæð vantar' },
    {
      validation: (amount) => amount <= 200000,
      message: 'Hámarksupphæð er 200.000 kr.',
    },
  ]);
  return (
    <MoneyInput
      inputRef={ref}
      isValid={isValid}
      errorMessage={message}
      onChangeValue={(amount) => setAmount(amount)}
      label="Upphæð á hverju korti"
      labelVariant="aboveInput"
      textAlign="center"
      variant="noBorder"
      inputSize="big"
      value={amount}
      id="amountOnCards"
      inputType="medium"
    />
  );
}
